import { ObjToQueryString } from "../utility-functions/UtilityFns";
import { getRequest, HandlerResponse, postRequest } from "./api";
import { API_URL } from "./Environment";

export const createConversationAPI = async(payload) => {
   return postRequest(`${API_URL}chat/conversation`,payload)
      .then((resp) => resp);
}

export const getChatHistoryAPI = async (_queryParams) => {
    const queryString = ObjToQueryString(_queryParams);
    return getRequest(`${API_URL}chat/get-chat-history${queryString}`)
      .then((resp) => HandlerResponse(resp));
  };
  